module.exports = __webpack_public_path__ + "static/people_img20-fcc4173fc2453aff5d586489fd3d32d8.png";